import * as helper from './../../../Assets/Js/helper';

function initImprint(impressumLink: Element, datenschutzLink: Element, agbLink: Element, link2257: Element) {
	const blocker = helper.$('#blocker');
	const closer = blocker.querySelector('#imprintCloser');
	const impressum = helper.$('#impressum');
	const datenschutz = helper.$('#datenschutz');
	const agb = helper.$('#agb');
	const elem2257 = helper.$('#t2257');

	helper.addClickListener(closer, (e:MouseEvent) => {
		e.preventDefault();
		helper.hide(blocker);
	})

	helper.addClickListener(impressumLink, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(blocker);
		helper.show(impressum);
		helper.hide(datenschutz);
		helper.hide(agb);
		helper.hide(elem2257);
	})

	helper.addClickListener(datenschutzLink, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(blocker);
		helper.show(datenschutz);
		helper.hide(impressum);
		helper.hide(agb);
		helper.hide(elem2257);
	})

	helper.addClickListener(agbLink, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(blocker);
		helper.show(agb);
		helper.hide(impressum);
		helper.hide(datenschutz);
		helper.hide(elem2257);
	});

	helper.addClickListener(link2257, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(blocker);
		helper.show(elem2257);
		helper.hide(impressum);
		helper.hide(datenschutz);
		helper.hide(agb);
	});
}

export function ImprintHandler() {
	const imprintLink = helper.$('#impressumlink');
	const datenschutzlink = helper.$('#datenschutzlink');
	const agbLink = helper.$('#agblink');
	const link2257 = helper.$('#twotwofivesevenlink');

	initImprint(imprintLink, datenschutzlink, agbLink, link2257);
}
